import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PipelineCandidatesListView({ entries }) {

  const navigate = useNavigate();

  return (
    <div className="table-wrapper">

      <table className="table">

        <thead>
          <tr>
            <th>Nom</th>
            <th>Email</th>
            <th>Statut</th>
            <th>Source</th>
            <th>Priorité</th>
          </tr>
        </thead>

        <tbody>

          {entries.map(c => (
            <tr
              key={c.id}
              onClick={() => navigate(`/pipeline/${c.id}`)}
              style={{ cursor: 'pointer' }}
            >

              <td>  {c.full_name ||
   `${c.first_name || ''} ${c.last_name || ''}`.trim()}</td>
              <td>{c.email}</td>
              <td>{c.pipeline_status}</td>
              <td>{c.source_type}</td>
              <td>{c.priority}</td>

            </tr>
          ))}

        </tbody>

      </table>

    </div>
  );
}
